<template>
  <tameo-sidebar-app-shell :menuItems="menuItems">
    <template v-slot:toolbarContent>
      <h1
        class="font-bold text-2xl pt-3 md:text-3xl md:pt-2 text-gray-700 flex-1"
      >
        Tameo's Indexes
      </h1>
    </template>
    <template v-slot:sidebarTitle>
      <img src="./assets/tameo-logo.png" />
    </template>
    <router-view></router-view>
  </tameo-sidebar-app-shell>
</template>

<script>
import gql from 'graphql-tag'
import EventBus from './event-bus/EventBus'
import { TameoSidebarAppShell } from 'tameo-vue-library'

export default {
  components: {
    TameoSidebarAppShell,
  },
  apollo: {
    indexes: {
      query: gql`
        query {
          indexes {
            id
            name
            isCustom
          }
        }
      `,
      fetchPolicy: 'cache-and-network',
    },
  },
  created() {
    EventBus.$on('indexCreated', () => this.$apollo.queries.indexes.refetch())
    EventBus.$on('indexDeleted', () => this.$apollo.queries.indexes.refetch())
  },
  data() {
    return {
      indexes: [],
    }
  },
  computed: {
    menuItems() {
      const items = this.indexes.map((i) => ({
        title: i.name,
        url: `/index${i.isCustom ? '/custom' : ''}/${i.id}`,
        icon: 'chart-line',
      }))
      items.push({ title: 'Create index', url: '/createindex', icon: 'plus' })
      return items
    },
  },
}
</script>

<style></style>
